/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDzXzM%7Bborder-radius%3Avar(--ds-radius-small%2C3px)%7D%0A._0KLXruB4sa%7Bbackground-color%3Avar(--ds-background-inverse-subtle%2C%2300000029)%7D%0A._0Of8r2dnbC%7Bpadding-top%3A0%7D%0A._1wydGWdnbC%7Bpadding-bottom%3A0%7D%0A._2Zuz6QFQfX%7Bpadding-left%3Avar(--ds-space-025%2C2px)%7D%0A._1ZnuxbFQfX%7Bpadding-right%3Avar(--ds-space-025%2C2px)%7D%0A._1iKH5nD0un%7Blabel%3Atooltip-shortcut%7D");






import React, { Fragment } from 'react';
import { formatShortcut } from '../../util/format-shortcut';
import type { Keymap } from '../../util/keymaps';
const tooltipShortcutStyle = null;
export const ToolTipContentWithKeymap: React.MemoExoticComponent<({
  description,
  shortcutOverride,
  keymap
}: {
  description?: string | React.ReactNode;
  keymap?: Keymap;
  shortcutOverride?: string;
}) => JSX.Element | null> = React.memo(({
  description,
  shortcutOverride,
  keymap
}: {
  description?: string | React.ReactNode;
  keymap?: Keymap;
  shortcutOverride?: string;
}): JSX.Element | null => {
  const shortcut = shortcutOverride || keymap && formatShortcut(keymap);
  return shortcut || description ? <Fragment>
				{description}
				{shortcut && description && '\u00A0'}
				{shortcut && <span className={ax(["_0bjKvDzXzM _0KLXruB4sa _0Of8r2dnbC _1wydGWdnbC _2Zuz6QFQfX _1ZnuxbFQfX _1iKH5nD0un"])}>{shortcut}</span>}
			</Fragment> : null;
});